import LocationView from 'text!../locationsAndBuildings/location/location.html';
import BuildingView from 'text!../locationsAndBuildings/building/building.html';

import LocationCtrl from '../locationsAndBuildings/location/locationCtrl';
import BuildingCtrl from '../locationsAndBuildings/building/buildingCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        cppLocation: {
            parent: wizardParentState,
            template: LocationView,
            controller: LocationCtrl,
            params: {
                initialPage: null
            }
        },
        cppBuilding: {
            parent: wizardParentState,
            template: BuildingView,
            controller: BuildingCtrl,
            params: {
                building: null,
                location: null,
                initialPage: null
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/config/RouteConfig.js
// module id = 808
// module chunks = 0